import { put, call, takeLatest } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import CustomerTransferGateway from '~apis/customerTransfer';
import { PayloadAction } from '@reduxjs/toolkit';

export default function* watchGetCustomerTransferSummary(api: CustomerTransferGateway): SagaWatcherReturnType {
    yield takeLatest('customerTransfer/customerTransferGetCustomerTransferSummaryAttempt', handleGetCustomerTransferSummary, api);
}

function* handleGetCustomerTransferSummary(api: CustomerTransferGateway, action: PayloadAction<{ id: number }>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { id } = action.payload;

    const response = yield* call([api, api.getCustomerTransferDraftSummary], {
        authToken,
        id,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerTransferGetCustomerTransferSummaryFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerTransferGetCustomerTransferSummarySuccess(response.data));
    }
}
